import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { catchError, Observable, tap } from 'rxjs';
import { ErrorHandlerService } from 'src/app/share/services/error-handler.service';
const apiurl = environment.apiUrl;
const level = 2;
@Injectable({
  providedIn: 'root'
})
export class MainCategoryService {

  constructor(private readonly http: HttpClient, private readonly errorHandler: ErrorHandlerService) { }
  createItem(data: any): Observable<any> {
      return this.http.post<any>(`${apiurl}/categoryhierarchy`, data).pipe(
        tap((response) => response),
        catchError((error) => this.errorHandler.handleError(error))
      );
    }
  
    getItems(param: HttpParams = null): Observable<any> {
      return this.http.get<any>(`${apiurl}/categoryhierarchy/level/${level}`, { params: param }).pipe(
        tap((response) => response),
        catchError((error) => this.errorHandler.handleError(error))
      );
    }
  
    updateItem(data: any): Observable<any> {
      return this.http.post<any>(`${apiurl}/categoryhierarchy/update`, data).pipe(
        tap((response) => response)
      );
    }
  
    deleteItem(data: any): Observable<any> {
      const obj={id:data.deleted_id};
      return this.http.post<any>(`${apiurl}/categoryhierarchy/delete`, obj).pipe(
        tap((response) => response)
      );
    }

    getGroupOption(): Observable<any> {
      return this.http.get<any>(`${apiurl}/categoryhierarchy/option`).pipe(
        tap((response) => response),
        catchError((error) => this.errorHandler.handleError(error))
      );
    }
}
